<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";
import CkeditorConfig from "@wielink-application/shared/js/ckeditor/ckeditor-config";

export default {
  mixins: [formInput],
  props: {
    'config': {
      type: Object,
      required: false,
      default: CkeditorConfig
    },
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  },
  mounted() {
    this.initialiseWysiwyg();

    this.$watch('modelValue', () => {
      let wysiwyg = $(this.$refs.input).data('wysiwyg');
      if (!$(document.activeElement).hasClass('ck')) {
        wysiwyg.setData(this.modelValue);
      }
    });
  },
  methods: {
    async initialiseWysiwyg() {
      let wysiwyg = await ClassicEditor
          .create(this.$refs.input, this.config)
          .catch(error => console.log(error));

      $(this.$refs.input).data('wysiwyg', wysiwyg);

      wysiwyg.model.document.on('change:data', () => {
        let value = wysiwyg.getData();
        this.changeModelValueTo(value);
      });
    }
  }
}
</script>

<template>
  <div :class="{'ckeditor-has-error' : hasError }">
    <div ref="input" v-html="modelValue"></div>
  </div>

  <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>